import { Component, OnInit, HostListener } from '@angular/core';
import { ArticleService } from '../services/article.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.css']
})
export class DetailComponent implements OnInit {
  isCollapsed = false;
  post:any=[];
  comment:any=[];
  postId:string;
  data: any[] = [];
  submitting = false;
  inputValue = '';
  likeId:string;
  liked:boolean;
  loading = false;

  getFullYear: number = new Date().getFullYear();
  constructor(
    private articleService: ArticleService,
    private readonly routerLinkActive: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.getUrl();
    this.getPost();
  }

  getPost(){
    this.loading = true;
    this.articleService.getDetail(this.postId).subscribe((res:any)=>{
      this.post = res.data;
      this.liked = res.data.is_like;
      this.loading = false;
    });
  }

  getUrl(){
    this.routerLinkActive.paramMap.subscribe((params:any)=>{
      this.postId = params.get('name');
    })
  }

  postLike(){
    // this.post.total_like = this.post.total_like + 1
    const value = {
      "article": this.postId
    }
    
    if(this.liked == false){
      {
        this.articleService.postLike(value).subscribe(
          data => {
            this.post.total_like = this.post.total_like + 1;
            this.liked = true;
            // console.log(this.liked);
          },
          error =>{

          });

      }
    }
    
    if(this.liked == true){
      this.articleService.deleteLike(this.postId).subscribe(
        res => {
          // console.log('res', res);
          this.post.total_like = this.post.total_like - 1;
          this.liked = false;
          // console.log(this.liked);
        }
      );
    }
  }

}
